import React from "react"
import logo from "../assets/carousel/Logo.png"
import "./styles/Navbar2.css"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, Link, NavLink } from "react-router-dom"
import { ScrollTextIcon, Phone, MessageSquare } from "lucide-react"
import { cartQuantity } from "../util"

function Navbar2() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const cart = useSelector((state) => state.cart)
  const cartItems = cart?.cartItems || []
  const cartDisplayQuantity = cartQuantity(cartItems)

  return (
    <nav className="navbar2">
      <img src={logo} alt="Company Logo" className="companylogo" />
      <div className="contactButtons">
        <a href="tel:1234567890" className="header-phone-link">
          <button className="navbar-btn phone-btn">
            <Phone className="phone-icon" />
          </button>
        </a>

        <button className="navbar-btn quote-btn">
          <MessageSquare className="messagesquare-icon" />
          BOOK US ONLINE NOW!!
        </button>
      </div>

      <input type="checkbox" id="menuToggle" className="menu-toggle" />
      <label htmlFor="menuToggle" className="burger">
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </label>

      <ul className="navbar-list desktop-navbar">
        {" "}
        {/* Opening tag added here */}
        <li className="navbar-item">
          <Link to="/" className="navbar-link">
            Home
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/about" className="navbar-link">
            About
          </Link>
          <ul className="dropdown">
            <li className="navbar-item">
              <Link to="/gallery" className="navbar-link">
                Gallery
              </Link>
            </li>
          </ul>
        </li>
        <li className="navbar-item">
          <Link to="/gutters" className="navbar-link">
            Gutters
          </Link>
          <ul className="dropdown">
            <li className="navbar-item">
              <Link to="/gutterguards" className="navbar-link">
                Gutter Guards
              </Link>
            </li>
          </ul>
        </li>
        <li className="navbar-item">
          <Link to="/cleaningandrepairs" className="navbar-link">
            Cleaning & Repairs
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/contact" className="navbar-link">
            Contact
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/reviews" className="navbar-link">
            Reviews
          </Link>
        </li>
        <li className="navbar-item">
          <NavLink to="/products" className="navbar-link">
            Products
          </NavLink>
        </li>
        {/* <li className="navbar-item">
          <NavLink to="/orders" className="navbar-link">
            Orders
          </NavLink>
        </li> */}
      </ul>

      <ul className="navbar-list mobile-navbar">
        <Link to="/" className="navbar-link">
          {" "}
          Home
        </Link>
        <Link to="/about" className="navbar-link">
          About
        </Link>
        <Link to="/gallery" className="navbar-link">
          Gallery
        </Link>
        <Link to="/gutters" className="navbar-link">
          Gutters
        </Link>
        <Link to="/gutterguards" className="navbar-link">
          Gutter Guards
        </Link>
        <Link to="/cleaningandrepairs" className="navbar-link">
          Cleaning & Repairs
        </Link>

        <Link to="/contact" className="navbar-link">
          Contact
        </Link>
        <Link to="/reviews" className="navbar-link">
          Reviews
        </Link>
        <Link to="/products" className="navbar-link">
          Products
        </Link>
        {/* <Link to="/orders" className="navbar-link">
          Orders
        </Link> */}
        {/* <button className="navbar-link" onClick={handleLogin}>
          Login | Sign Up
        </button> */}
      </ul>
    </nav>
  )
}

export default Navbar2
